import {forEach} from 'lodash'
import { scrollToTop, formateCurrency, redirect } from "./utility"
import { pageStart } from "./core/page-loader"

let $hamburger = $(".hamburger"),
    $header = $('header'),
    $menuWrapper = $("header .menu-wrapper"),
    $overlay = $("#overlay")

require("./modals")

$( document ).ready(() => {
    //Hamburger Click-Event
    $hamburger.on("click", function() {
        $hamburger.toggleClass("is-active")
        $header.toggleClass("is-active")
        $menuWrapper.toggleClass("is-active")
        $overlay.toggleClass("is-active")
    })

    $('a', 'header .menu-wrapper').not( ".toggle-lang-dd" ).click(function () {
        $hamburger.removeClass("is-active")
        $header.removeClass("is-active")
        $menuWrapper.removeClass("is-active")
        $overlay.removeClass("is-active")
    })

    require('./core/notification')

    //resize slick trades slider on window resize
    $(window).on('resize', function() {
        $('.trades-slider').slick('resize')
    })

    //Call a Calculation
    $('.call-calculation').click(function() {
        let calcId = $(this).attr('data-calculation-id')
        window.location = "/calculation/"+calcId+"/activate"
    })

    //Back to top
    $('.back-to-top-btn').click(function () {
        scrollToTop()
    })

    //Stop propagation
    $('.stop-propagation').on('click', function () {
        event.stopPropagation()
    })


    $('.formateCurrency').each(function() {
        $(this).html(formateCurrency($(this).text()))
    })

    //Download PDF
    $( ".pdf-selector" ).change(function() {
        let value = $(this).val()

        if(value) {
            redirect(value)
        }
    })

    $('.download-pdf').click(function (e) {
        e.preventDefault()

        let calculationId = $(this).attr('data-calculation-id'),
            $pdfSelector = $('#pdf-selector-'+calculationId),
            pdfSelectorValue = $pdfSelector.val()
    })

    pageStart()

    $(document).on('click', '.open-contact-form', function(e) {
        e.preventDefault()
        let scope = e.target.getAttribute('data-scope')
        window.EventBus.$emit('call-contact-modal', {scope})
    });
})

const { detect } = require('detect-browser')

const browser = detect()

// handle the case where we don't detect the browser
if(browser.name === 'safari' || browser.name === 'ios') {
    $('body').addClass('modal-overflow-hidden')
}